import { colors } from '@constants/colors';

export const useStyles = () => ({
  root: {
    overflowY: 'scroll',
    maxHeight: 300,
    '& p': {
      color: colors.white,
    },
  },
  placeholder: {
    color: colors.white_60,
    fontSize: 13,
  },
  section: {
    mb: 2,
  },
  sectionTitle: {
    color: colors.white,
    fontWeight: 'bold',
    fontSize: 13,
    mb: 1,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '4px 16px',
  },
  statLabel: {
    color: colors.white_60,
    fontSize: 12,
  },
  statValue: {
    color: colors.white,
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'right',
  },
  controlRow: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
    mb: 1.5,
  },
  hint: {
    color: colors.white_60,
    fontSize: 11,
    fontStyle: 'italic',
    mt: 0.5,
  },
  badge: {
    color: colors.white,
    background: colors.red,
    borderRadius: 1,
    px: 1,
    py: 0.25,
    fontSize: 11,
    display: 'inline-block',
    mb: 1,
  },
  numberInput: {
    width: 110,
    '& .MuiOutlinedInput-input': {
      color: colors.white,
      py: 0.75,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.white_40,
    },
  },
  select: {
    minWidth: 160,
    color: colors.white,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.white_40,
    },
    '& .MuiSvgIcon-root': {
      color: colors.white,
    },
  },
});
